import React from 'react';
import { Wrapper } from './Menu.styled';
import { onMoveAnimation } from 'services/hooks/useDevelopUI';
import CloseIcon from '@mui/icons-material/Close';
import { useHistory } from 'react-router-dom';
export const MenuForm = () => {
  const history = useHistory();
  return (
    <Wrapper id="menu-modal-ov" className="menu-modal">
      <div
        className="overlay"
        onClick={() => {
          onMoveAnimation('menu-modal-ov', 'moveOutOpacity');
        }}
      ></div>
      <div className="setting-form">
        <div className="setting-title">
          <div className="title">Menu</div>
          <div
            className="btn-close"
            onClick={() => {
              onMoveAnimation('menu-modal-ov', 'moveOutOpacity');
            }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="border"></div>
        <div
          className="menu-nav"
          onClick={() => {
            history.push('/');
            onMoveAnimation('menu-modal-ov', 'moveOutOpacity');
          }}
        >
          Home
        </div>
        <div
          className="menu-nav"
          onClick={() => {
            window.open('https://app.galoswap.io/', 'blank');
          }}
        >
          Swap
        </div>
        <div
          className="menu-nav"
          onClick={() => {
            window.open('https://app.galoswap.io/liquidity', 'blank');
          }}
        >
          Liquidity
        </div>
        <div
          className="menu-nav"
          onClick={() => {
            window.open('https://app.galoswap.io/leaderboard', 'blank');
          }}
        >
          Leaderboard
        </div>
      </div>
    </Wrapper>
  );
};

export default MenuForm;
